import React, { useState, useEffect,useMemo } from "react";
import ViewStocktakeForm from "./ViewStocktakeForm";
import StartStocktakeSessionForm from "./StartStocktakeSessionForm"
import StocktakeTypeSelectionForm from "./StocktakeTypeSelectionForm"

const StocktakeSearch = ({ refreshTrigger }) => {
  const [sessions, setSessions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedSession, setSelectedSession] = useState(null);
  const [showView, setShowView] = useState(false);
  const [showStartStocktakeSessionForm, setShowStartStocktakeSessionForm] = useState(false)
  const [inventory, setInventory] = useState([]);
  const [secureData, setSecureData] = useState(null);

    const currentUserId = useMemo(() => {
    const payload = secureData?.admin || secureData?.auth || null;
    return payload?.user_id ?? payload?.admin_id ?? null;
  }, [secureData]);

  const fetchSessions = () => {
    fetch("/api/stocktake/sessions")
      .then((r) => r.json())
      .then((data) => setSessions(data))
      .catch((e) => console.error("Error fetching stocktakes:", e));
  };

    // API fetchers
  const fetchProducts = () => {
    fetch("/api/products")
      .then((r) => {
        if (!r.ok) throw new Error("Failed to fetch products");
        return r.json();
      })
      .then(setInventory)
      .catch((e) => console.error("Error fetching products:", e));
  };


      // ✅ Refresh User List After Adding
    const handleSessionAdded = () => {
      fetchSessions();
      setShowStartStocktakeSessionForm(false);
    };

  const handleView = async (sessionId) => {
    try {
      // Fetch full details for the modal (adjust endpoints to match your server)
      const [sessionRes, itemsRes] = await Promise.all([
        fetch(`/api/stocktake/sessions/${sessionId}`),
        fetch(`/api/stocktake/sessions/${sessionId}/lines`),
      ]);
      const session = await sessionRes.json();
      const items = await itemsRes.json();
      setSelectedSession({ ...session, items });
      setShowView(true);
    } catch (e) {
      console.error("Error fetching session details:", e);
    }
  };

  useEffect(() => {
    fetchSessions();
    fetchProducts();
  }, [refreshTrigger]);

  const filteredSessions = sessions.filter((s) => {
    const q = searchQuery.toLowerCase();
    return (
      (s.name || "").toLowerCase().includes(q) ||
      (s.location_name || "").toLowerCase().includes(q) ||
      (s.status || "").toLowerCase().includes(q) ||
      (s.scope || "").toLowerCase().includes(q)
    );
  });

      const handleAddSession = () => {
      setShowStartStocktakeSessionForm(true);
    };

  return (
    <div className="user-list-container">
      <h2>Stock-Take Sessions</h2>

      <div>
        <label>Search:</label>
        <input
          type="text"
          placeholder="Search by name, location, status…"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <div className="button-container">
        <button className="add-user-button" onClick={handleAddSession}>Start Stocktake Session</button>
      </div>

      <div className="UserList-container">
        <table>
          <thead>
            <tr>
              <th className="first-child">ID</th>
              <th>Session Name</th>
              <th>Status</th>
              <th>Started</th>
              <th>Ended</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredSessions.length > 0 ? (
              filteredSessions.map((s) => (
                <tr key={s.session_id}>
                  <td className="first-child">{s.session_id}</td>
                  <td>{s.name}</td>
                  <td>{s.status}</td>
                  <td className="date-cell">
                    {s.started_at ? (
                      <>
                        {new Date(s.started_at).toLocaleDateString()}
                        <time>{new Date(s.started_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</time>
                      </>
                    ) : "-"}
                  </td>

                  <td className="date-cell">
                    {s.ended_at ? (
                      <>
                        {new Date(s.ended_at).toLocaleDateString()}
                        <time>{new Date(s.ended_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</time>
                      </>
                    ) : "-"}
                  </td>
                  <td>
                    <button onClick={() => handleView(s.session_id)}>View</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7">No stock-take sessions match your search.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
        {showStartStocktakeSessionForm && (
          <StocktakeTypeSelectionForm
            onClose={() => setShowStartStocktakeSessionForm(false)}
            inventory={inventory}
            fetchProducts={fetchProducts}
            userId={currentUserId}
            onSessionAdded={fetchSessions}
          />
        )}

      {showView && selectedSession && (
        <ViewStocktakeForm
          selectedSession={selectedSession}
          onClose={() => setShowView(false)}
        />
      )}
    </div>
  );
};

export default StocktakeSearch;
